import { Injector } from '@angular/core';
import { DocumentsService } from '@data-access/documents/services';
import { DocumentTypeExtended } from '@data-access/documents/types';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { IResults } from '@shared/iris.interface';
import { of, pipe, switchMap } from 'rxjs';

const documentTypeEntity = () =>
  entityConfig({
    collection: '_documentTypes',
    entity: type<DocumentTypeExtended>(),
    selectId: (entity: DocumentTypeExtended) => entity.id,
  });

export const withDocumentTypeEntities = (_injector: Injector) => {
  return signalStoreFeature(
    withEntities(documentTypeEntity()),
    withMethods((store) => {
      const _fetchDocumentTypes = rxMethod<{ workspaceId?: string }>(
        pipe(
          switchMap(({ workspaceId }) => {
            if (!workspaceId) {
              console.error('workspaceId not set');
              patchState(
                store,
                setAllEntities(
                  [] as DocumentTypeExtended[],
                  documentTypeEntity(),
                ),
              );
              return of([]);
            }

            const docService = _injector.get(DocumentsService);
            return docService.getSubmissionDocumentTypes({ workspaceId }).pipe(
              tapResponse({
                error: (error: Error) => {
                  console.error('Error loading document types:', error);
                },
                next: (response: IResults<DocumentTypeExtended>) => {
                  patchState(
                    store,
                    setAllEntities(response.data, documentTypeEntity()),
                  );
                },
              }),
            );
          }),
        ),
      );
      return {
        setDocumentTypes: (params: { workspaceId?: string }) =>
          _fetchDocumentTypes(params),
      };
    }),
  );
};
